<template>
    <v-container class="pa-0" v-if="profile">
        <lbls>src\views\a4l\playercomponents\AdminPanel.vue</lbls>

        <v-row>
            <v-col md="12" lg="8">
                <v-card elevation="0" outlined>
                    <v-card-title class="font-weight-light">
                        Admin Panel
                        <v-spacer />
                        <div style="display: inline-block;text-align: center;">
                            <v-avatar size="80"><v-img :src="profile.info.profilepic" /></v-avatar>
                            <div class="subtitle-1 font-weight-light">{{profile.info.firstname}} {{profile.info.lastname}}</div>
                        </div>
                    </v-card-title>
                    <v-card-text>
                        <v-row>
                            <v-col cols="6" class="py-0 text-left">
                                <v-card elevation="0" outlined>
                                    <v-card-title class="subtitle-2 font-weight-light">
                                        <v-btn text x-small v-if="gettingcontacts" :loading="gettingcontacts"></v-btn>
                                        Contacts
                                    </v-card-title>
                                    <v-card-text>
                                        <v-row>
                                            <v-col cols="12" class="py-0 text-left">
                                                <v-list dense>
                                                    <v-list-item v-for="(l,i) in linkedcontacts" @click="viewContact(l)">
                                                        <v-list-item-content>
                                                            <v-list-item-title>
                                                                {{l.name}} <v-icon v-if="billing && l.uuid===billing.uuid" color="green">{{icons.dollar}}</v-icon>
                                                            </v-list-item-title>
                                                            <v-list-item-subtitle>
                                                                {{l.cell}} | {{l.email || 'no email'}}
                                                            </v-list-item-subtitle>
                                                        </v-list-item-content>
                                                        <v-list-item-action>
                                                            <v-btn x-small icon @click.stop="deleteContact(l,i)">
                                                                <v-icon>{{icons.minus}}</v-icon>
                                                            </v-btn>
                                                            <v-list-item-action-text>Remove</v-list-item-action-text>
                                                        </v-list-item-action>
                                                    </v-list-item>
                                                </v-list>
                                            </v-col>
                                        </v-row>
                                    </v-card-text>
                                    <v-card-actions>
                                        <v-btn @click="contactdialog=true" x-small text>
                                            <v-icon small>{{icons.plus}}</v-icon> Add Contact
                                        </v-btn>
                                    </v-card-actions>
                                </v-card>
                                <v-card outlined class="mt-2" v-if="$prms(['director','financial'])">
                                    <v-card-title class="subtitle-2 font-weight-light">
                                        Billing
                                    </v-card-title>
                                    <v-card-text v-if="billing">
                                        Price {{billing.price}}
                                        <v-list>
                                            <a v-for="n in invoices" :href='`https://www.paypal.com/invoice/p/#${n.invoiceId||n.id}`' target="_blank">
                                            <v-list-item >
                                                <v-list-item-content>
                                                    <v-list-item-subtitle>
                                                        {{n.invoiceId||n.id}} | {{n.status}}
                                                     </v-list-item-subtitle>
                                                </v-list-item-content>
                                            </v-list-item>
                                            </a>
                                        </v-list>
                                    </v-card-text>
                                    <v-card-actions>
                                        <SetPlayerBilling :profile="profile" />
                                        <v-spacer/>
                                        <v-btn small text v-if="billing" :loading="invoicing" @click="openInvoiceDialog()">Invoice</v-btn>
                                    </v-card-actions>
                                </v-card>
                                <AddToGroup small :keystoadd="keystoadd" @done="handleDone($event)"/>
                                Member Groups
                            </v-col>
                            <v-col cols="9" class="py-0">
                                <ProfileGroups v-if="groups"
                                               :profilekey="profile.partkey"
                                               :groupids="groups"
                                               @done="handleDone($event)"
                                />
                            </v-col>
                        </v-row>

                    </v-card-text>
                    <Lbls>src\views\a4l\playercomponents\ProfileAdminPanel.vue</Lbls>
                </v-card>
            </v-col>
        </v-row>

        <v-dialog v-model="contactdialog" max-width="450">
            <v-card>
                <v-card-title class="subtitle-2 font-weight-light">
                    Add Contact
                </v-card-title>
                <v-card-text>
                    <SearchContact :clear="true" dense @contact="saveContactToProfile($event)" />
                </v-card-text>
                <v-card-actions>
                    <v-btn x-small text @click="contactdialog=false">Cancel</v-btn>
                    <v-spacer/>
                    <QuickAdd small @newcontact="quickAddReturn($event)" />
                </v-card-actions>
            </v-card>
        </v-dialog>

        <v-dialog v-model="invoicedialog" persistent max-width="500">
            <v-card>
                <v-card-title>
                    Invoice for {{profile.info.firstname}} {{profile.info.lastname}}
                </v-card-title>
                <v-card-text>
                    Default amount: {{billing.price}}
                    <div>
                        Invoice sent to: {{billing.name}} | {{billing.email}}
                    </div>

                    <v-text-field outlined v-if="1===2" label="Invoice Code" v-model="invoicecode" ></v-text-field>
                    <InvoiceCodeSearch @code="invoicecode=$event" />
                    {{invoicecode}}
                    <v-text-field outlined label="Description for line item" v-model="invoicelineitem"></v-text-field>
                    <v-checkbox v-model="includeprice" label="Include Price" />
                    <v-text-field type="number" v-if="includeprice" v-model="price" label="Price" />
                </v-card-text>
                <v-card-actions>
                    <v-btn text @click="invoicedialog=false">Cancel</v-btn>
                    <v-spacer/>
                    <v-btn text @click="create()" :loading="invoicing">Create</v-btn>
                </v-card-actions>
            </v-card>
        </v-dialog>
    </v-container>
</template>

<script>
  import {
    mapState,
    mapActions,
    mapMutations
  } from 'vuex'
  import ProfileGroups from "@/components/groups/ProfileGroups";
  import AddToGroup from "@/components/groups/AddToGroup";
  import Lbls from "../../../components/Lbls";
  import SetPlayerBilling from "./SetPlayerBilling";
  import SearchContact from "@/views/contacts/SearchContact";
  import QuickAdd from "@/views/contacts/QuickAdd";
  import InvoiceCodeSearch from "../../../components/invoicing/InvoiceCodeSearch";

  export default {
    name: "AdminPanel",
    components: {InvoiceCodeSearch, QuickAdd, SearchContact, SetPlayerBilling, Lbls, AddToGroup, ProfileGroups},
    data() {
      return {
        groups: [],
        keystoadd: [],
        linkedcontacts: [],
        searchcontact: false,
        setdelete: false,
        gettingcontacts: false,
        contactdialog: false,
        invoicing: false,
        invoices:[],
        invoicedialog: false,
        invoicecode: '',
        invoicelineitem: '',
        includeprice: false,
        price: undefined
      }
    },
    mounted() {
      this.groups = this.profile.groups || []
      this.keystoadd = [this.profile.partkey] || []
      let em = this;
      setTimeout(function(){
        em.getLinkedContacts()
      },2000)
    },
    computed: {
      ...mapState(['icons','activeplayer','org','orgkey']),
      profile(){
        return this.activeplayer
      },
      billing(){
        return (this.activeplayer)?this.activeplayer.billing[this.org.partkey]:undefined
      }
    },
    watch: {
      profile(n, o) {
        console.log(n, o)
        this.groups = this.profile.groups || []
        if(n.info){
          this.keystoadd = [n.partkey]
        }
        this.getByPartkey()
        this.getLinkedContacts()
      }
    },
    methods: {
      ...mapActions(['get', 'post', 'put']),
      ...mapMutations(['setActivePlayer']),
      handleDone(e){
        if(e.error){
          return
        }else{
          let index = this.groups.findIndex(f=>{f===e.id})
          this.groups.splice(index,1)
        }
      },
      quickAddReturn(e){
        console.log(e)
      },
      async saveContactToProfile(event){
        this.contactdialog=false
        console.log(event);
        let data = {
          partkey: this.profile.partkey,
          sport: 'na',
          col: 'contacts',
          attribute: event.uuid,
          value: {
            uuid: event.uuid,
            relationship:''
          }
        }
        let p = await this.put({path: 'api/profilesv2', body: data})
        console.log(p)
        this.setActivePlayer(p)
        this.$forceUpdate()
        this.getLinkedContacts()
        this.contactdialog=false
      },
      async getLinkedContacts(){
        this.gettingcontacts = true;
        let data = {
          uuids: Object.keys(this.profile.contacts)
        }
        this.linkedcontacts = await this.post({path:'api/contacts/getlinked',body:data})
        this.gettingcontacts=false
      },
      async deleteContact(event,i){
        this.gettingcontacts = true;
        this.linkedcontacts.splice(i,1)
        let rsp = await this.post({path:'api/profilesv2/deletecontact',body:{partkey:this.profile.partkey,uuid:event.uuid}})
        console.log(rsp)
        this.setActivePlayer(rsp)
        this.$forceUpdate()
        this.getLinkedContacts()
      },
      viewContact(c){
        console.log(c)
      },
      Close(){
        this.$emit('close',true)
      },
      openInvoiceDialog(){
        this.invoicedialog=true
      },
      async create(){
        let em=this;
        setTimeout(function(){
          em.invoicing=false
        },5000)
        this.invoicing=true
        let data = {
          group: false, //will trigger individual logic instead of group logic on backend
          //customer:this.billing, //improve logic
          description:this.invoicelineitem,
          partkey: this.profile.partkey, //unique id for what ever is being billed
          code: this.invoicecode,
          includeprice: this.includeprice,
          price: this.price
        }
        this.loading=true
        let r = await this.post({path:'api/invoicesend/sendtogroupa4l',body:data})
        console.log(r)
        this.invoicecode=''
        this.invoicelineitem=''
        this.invoices.push(r)
        this.$emit('createdInvoice',r)
        this.invoicing=false
        this.invoicedialog=false
        this.includeprice = false
        this.price = 0
      },
      async getByPartkey(){
        this.invoices =  await this.post({path:'api/invoicing/getbypartkey/'+this.profile.partkey})
        console.log(this.invoices)
      }
    }
  }
  // {
  //   "scope":"https://uri.paypal.com/services/invoicing https://uri.paypal.com/services/disputes/read-buyer https://uri.paypal.com/services/payments/realtimepayment https://uri.paypal.com/services/disputes/update-seller https://uri.paypal.com/services/payments/payment/authcapture openid https://uri.paypal.com/services/disputes/read-seller https://uri.paypal.com/services/payments/refund https://api.paypal.com/v1/vault/credit-card https://api.paypal.com/v1/payments/.* https://uri.paypal.com/payments/payouts https://api.paypal.com/v1/vault/credit-card/.* https://uri.paypal.com/services/subscriptions https://uri.paypal.com/services/applications/webhooks",
  //   "access_token":"A21AANESvUOvbL1re2M_ROIQwgv8o41E-MagG3bKOQQu2vYeUyAUpk81nR3KUkB-XnLeyB4CO7ZG__7sTiDt3G5PC528ail_g",
  //   "token_type":"Bearer",
  //   "app_id":"APP-3DD35512P4798642C",
  //   "expires_in":31938,
  //   "nonce":"2020-12-05T05:18:43ZBU9EAk03iBOY9cxEOQkApxz2Atw42KMktb5ZFAmUNJg"
  // }
</script>

<style scoped>

</style>